import { defineMessages } from "react-intl";
export default defineMessages({
    title: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.title",
        defaultMessage: "How do you track work?",
        description: "Title for a modal about setting up the board columns"
    },
    subtitle: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.subtitle",
        defaultMessage:
            "As you complete work, it moves through these statuses.",
        description: "Subtitle for a modal about setting up the board columns"
    },
    statusInputPlaceholder: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.column-input-placeholder",
        defaultMessage: "Name of status",
        description:
            "Placeholder for text input fields for naming statuses in onboarding wizard modal"
    },
    addStatusButton: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.add-column-button",
        defaultMessage: "Add status",
        description:
            "Button text for adding a status input in onboarding wizard modal"
    },
    step: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.step",
        defaultMessage: "Step 3 of 3",
        description:
            "Current step of the onboarding wizard displayed in bottom left corner of the modal"
    },
    deleteTooltip: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.deleteTooltip",
        defaultMessage: "Minimum 3 statuses",
        description:
            "Tooltip text that appears when user hovers over disabled delete button when there are only three column statuses"
    },
    maxColumnsText: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.max-columns-text",
        defaultMessage: "Don't worry, you can change these later.",
        description:
            "Text that appears instead of the add status button when the maximum number of columns are added"
    },
    emptyInputErrorMessage: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.empty-input-error-message",
        defaultMessage: "Enter a name for this status",
        description:
            "Error text that appears if status name input is empty when finish button is pressed"
    },
    duplicateStatusErrorMessage: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.duplicate-status-error-message",
        defaultMessage: "Statuses can't share the same name",
        description:
            "Error text that appears if there are duplicate status name in inputs when finish button is pressed"
    },
    inputLengthErrorMessage: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.input-length-error-message",
        defaultMessage: "Status name can't exceed 30 characters",
        description:
            "Error text that appears if the status name is over 30 characters when finish button is pressed"
    },
    nextButtonCta: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.next-button-cta",
        defaultMessage: "Next",
        description: "CTA for the next button"
    },
    finishButtonCta: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.finish-button-cta",
        defaultMessage: "Finish",
        description: "CTA for the finish button"
    },
    deleteColumnButtonLabel: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.delete-column-button-label",
        defaultMessage: "Delete column {columnNumber}"
    },
    columnInputLabel: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.column-input-label",
        defaultMessage: "Column {columnNumber} name"
    }
});
